import React from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import posthog from 'posthog-js';
import { Module, RootModule } from 'core';
import { AppWrapper, NotFoundPage } from 'components';
import { getEnvVar } from 'util/env';
import { AnalyticsBrowser } from '@segment/analytics-next';

const analytics = AnalyticsBrowser.load({
    writeKey: 'YXw7pm8yEM4dMTeSB96ZWGhsi2mskNrb',
});

const INSTALL_MODULE: any = {
    'fe-cv': require('./module/fe-cv'),
};

class RootApplication extends React.Component<{}, { loading: boolean }> {
    rootModule: RootModule;
    constructor(props: {}) {
        super(props);
        this.state = {
            loading: true,
        };
        this.rootModule = new RootModule();
    }
    componentDidMount() {
        console.log('ENV:', getEnvVar('ENV'));
        this.init();
        analytics.page();
        analytics.identify('test_user_id', {
            email: 'user@example.com',
        });
        if (getEnvVar('TRACKING_ID')) {
            posthog.init(getEnvVar('TRACKING_ID'), {
                api_host: 'https://app.posthog.com',
            });
        }
    }
    setupModule() {
        for (const key in INSTALL_MODULE) {
            const module = new Module(key);
            INSTALL_MODULE[key].setup(module);
            this.rootModule.register(module);
        }
    }
    async init() {
        this.setState({ loading: true });

        // Setup module
        this.setupModule();

        this.setState({ loading: false });
    }
    renderRoute() {
        return Object.entries(this.rootModule.routes()).map(([key, route]) => {
            return <Route key={route.path} {...route} />;
        });
    }
    render() {
        if (this.state.loading) {
            return <span>Loading</span>;
        }
        return (
            <BrowserRouter basename="/">
                <AppWrapper>
                    <Switch>
                        {this.renderRoute()}
                        <Route component={NotFoundPage} />
                    </Switch>
                </AppWrapper>
            </BrowserRouter>
        );
    }
}

export { RootApplication };
